import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import Logo from './../assist/triokzzlohgo.svg';
import './Celebration.css'
import { Helmet } from 'react-helmet-async';
// import { app, auth } from "./firebase";
// Import the functions you need from the SDKs you need
import firebase from 'firebase/compat/app';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import SigninForm from './../admin/signin'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
    appId: process.env.REACT_APP_FIREBASE_APPID,
    measurementId: process.env.REACT_APP_FIREBASE_MESURMENTID,
        databaseURL: "https://loginwithphone-9fb64.firebaseio.com/"
};

// const firebaseConfig = {
//     apiKey: "AIzaSyB8YeifobKfJJSO3nselAILteDgp4iIAMA",
//     authDomain: "loginwithphone-9fb64.firebaseapp.com",
//     projectId: "loginwithphone-9fb64",
//     storageBucket: "loginwithphone-9fb64.appspot.com",
//     messagingSenderId: "395072549821",
//     appId: "1:395072549821:web:4f59770be42fda341a98d4",
//     measurementId: "G-RWZEXW6VMP"
// };

// Initialize Firebase

firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();

const Registration = (props) => {
    const navigate = useNavigate()
    const [mynumber, setnumber] = useState("");
    const [otp, setotp] = useState(new Array(6).fill(''));
    const [show, setshow] = useState(false);
    const [showloader, setshowloader] = useState(false);
    const [final, setfinal] = useState("");
    const [JWebToken, setJWebToken] = useState({})
    const [varified, setverified] = useState(false)
    const [messageStatus, setMessageStatus] = useState('');
      let ListOfOrdered = useSelector(state => state.allProducts.order)
    //   console.log(otp)
    // console.log("mynumber ", Object.keys(props).length === 0)
    // Sent OTP
    const signin = async() => {
        if (mynumber === "" || mynumber.length < 10) return;
        setshowloader(true)

        // let verify = new firebase.auth.RecaptchaVerifier(
        //     'recaptcha-container');
        let verifyed = await new firebase.auth.RecaptchaVerifier(
            'recaptcha-container', {
            size: "invisible",
            callback: function (response) {
                console.log('workrs')
            }
        })
        verifyed.render()
        verifyed.verify()
        // console.log("mynumber ", mynumber, verifyed)
        firebase.auth().signInWithPhoneNumber(`+91${mynumber}`, verifyed)
            .then((result) => {
                setfinal(result);
                toast(
                    <span>
                        <b>OTP Sent To Your Mobile Number</b>
                    </span>,
                    {
                        icon: '😀☞',
                    },
                    {
                        duration: 3000,
                      }
                )
                setshow(true)
            })
            .catch((err) => {
                alert(err);
                // window.location.reload();
            });
    };

    // Validate OTP
    const ValidateOtp = async() => {
        if (otp === null || final === null) return;
        await final
            .confirm(otp)
            .then((result) => {
  
                localStorage.setItem('PHONEOTPINFO', JSON.stringify(result && result.user && result.user.multiFactor && result.user.multiFactor.user))

            //    setotpResult(result)
                // console.log(Object.keys(props).length )
                // if(Object.keys(props).length === 0){
                //     navigate("/paymentgetway")
                //    }else{
                //     props.close()
                //    }
                firebase.auth().signOut().then((r) => {
                    // Sign-out successful.
                    toast(
                        <span>
                            <b>Authenticate successfully, Please submit</b>
                        </span>,
                        {
                            icon: '🤝',
                        }
                    )
                    // sendMessage(result && result.user && result.user.multiFactor && result.user.multiFactor.user)
                    setshowloader(false)
                    setverified(true)
                    if(typeof window.fbq === 'function' && window.fbq.loaded){
                        window.fbq('track', 'InitiateCheckout', {
                          content_ids: [ListOfOrdered && ListOfOrdered[0].id],
                          currency: 'INR',
                          num_items: 1,
                          value: ListOfOrdered && ListOfOrdered[0].price
                        });
                    }
                }).catch((error) => {
                    console.log(error)
                    // An error happened.
                })
            })
            .catch((err) => {
                console.log(err)
                alert("Please Enter Correct OTP");

            });
    };
    return (
        <div className="flex min-h-full flex-col justify-center ">
            <Helmet>
                <meta name="google-site-verification" content="vwUAwcHi4pY-Lgm6a9JJyOwn1GLbkA7gO6fvQOy4FvU" />
                <meta name="keywords" content="you tees, womens basic tee shirt, indoor decor, home decor items near me, sculptures, inspiring, large luggage bags, popular duffle, touring bags, big size travel bags online, purse, wholesale mugs, custom cups and mugs, ceramic printed mugs, copper drinking mugs, cups for camping, purses for women, purse sale, branded bags for women, multi pocket bags"></meta>
                {/* <meta property="og:title" content="Triokzz - Things to buy online: Top 99 home products for bharat 🛒" /> */}
                <meta property="og:image" content="https://shopnowindia.s3.ap-south-1.amazonaws.com/Triokzz+Bags/Grey+colour/Grey+color+Travelling+bag_1.png" />
                <meta property="og:image:height" content="1200" />
                <meta property="og:image:width" content="630" />
                <meta property="og:url" content="https://www.triokzz.com/product/all" />
                <meta property="og:image:alt" content="Images T-shirt Mugs Travel Bags Mouse Pad" />
                <meta property="og:site_name" content="Triokzz your shopping partner 🛒" />
            </Helmet >
            <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                {/* <form className="space-y-6" action="#" method="POST"> */}
                <center>
               <SigninForm varified={varified} close={()=>props.close()} mynumber={varified && mynumber}/>
                    {/* <p>{JWebToken.name}</p> */}
                    <div
                        style={{ display: show ? "none" : "block" }}
                    >
                        <label htmlFor="user" className="mt-2 block text-sm font-medium leading-6 text-white" id="user">Verify your phone number</label>
                        <div className="flex items-center justify-center">
                            <button id="dropdown-phone-button" data-dropdown-toggle="dropdown-phone" className="flex-shrink-0 z-10 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-s-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700 dark:text-white dark:border-gray-600" type="button">
                                <svg className="w-5 h-5" enableBackground="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><circle cx="256" cy="256" fill="#f0f0f0" r="256" /><path d="m256 0c-101.494 0-189.19 59.065-230.598 144.696h461.195c-41.407-85.631-129.104-144.696-230.597-144.696z" fill="#ff9811" /><path d="m256 512c101.493 0 189.19-59.065 230.598-144.696h-461.196c41.408 85.631 129.104 144.696 230.598 144.696z" fill="#6da544" /><circle cx="256" cy="256" fill="#0052b4" r="89.043" /><circle cx="256" cy="256" fill="#f0f0f0" r="55.652" /><path d="m256 187.326 17.169 38.938 42.304-4.601-25.136 34.337 25.136 34.337-42.304-4.601-17.169 38.938-17.169-38.938-42.304 4.6 25.136-34.336-25.136-34.337 42.304 4.601z" fill="#0052b4" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>
                                +91 <svg className="w-2.5 h-2.5 ms-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" /></svg>
                            </button>
                            <div className="relative">
                                <input
                                    name="phone"
                                    value={mynumber}
                                    onChange={(e) => {
                                        setnumber(e.target.value);
                                    }}

                                    type="string" autoComplete="phone" id="phone-input" className="block w-full rounded-md border-0  text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" maxLength={10} pattern="/^\d{10}$/" placeholder="Active number xxxxxxxxxx" required />
                            </div>
                        </div>

                        <button
                            type="button"
                            className="mt-2 p-1 items-center justify-center font-medium bg-indigo-600 text-white hover:text-white"
                            onClick={() => signin()}>
                            Send OTP
                        </button>
                        <br />

                        <br />
                        <div id="recaptcha-container"></div>
                    </div>
                    {/* {otp.length == 6 && showloader ?  <div class="spinner-4 relative w-12 animate-spin">
        <div class="absolute top-0 left-0  bg-orange-600 w-4 h-4 rounded-full"></div>
        <div class="absolute top-1/2 right-0 bg-black w-4 h-4 rounded-full"></div>
      </div> : ""} */}
                    <div
                        style={{
                            display: show ? "block" : "none",
                        }}
                        className="flex sm:mx-auto sm:w-full sm:max-w-sm"
                    >
{/* 
                        <img
                            className="mx-auto h-14 w-25"
                            src={Logo}
                            alt="shoptodecore"
                        /> */}
                        {/* <h2 className="m-5 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900 bg-gradient-to-r from-red-400 to-green-300 ">OTP Verification</h2> */}
                        {!varified?<input
                            type="text"
                            placeholder={"Enter the OTP you received"}
                            onChange={(e) => {
                                setotp(e.target.value);
                            }}
                            name="otp"
                            autoComplete="one-time-code"
                            maxLength="6"
                            inputMode="numeric"
                            className="block w-full rounded-md border-0 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />:""}
                        <br />
                        <br />
                       {showloader == true ? <button
                            type="button"
                            className=" p-1 font-medium bg-indigo-600 text-white hover:text-indigo-500"
                            onClick={() => ValidateOtp()}>
                            Verify
                        </button>:""}
                    </div>

                </center>
                {/* </form> */}
            </div>
        </div>
    )
}

export default Registration;